'use client';

import { cn } from '@core/utils';
import dayjs from 'dayjs';

import { useRemainingTime } from './_hooks/useRemainingTime';
import { padNumber } from './_utils/padNumber';

/** 숫자 사이즈 동일하게 하려고 코드 문자 사용 */
const FONT_FAMILY = 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace';

interface BottomTimerProps {
  endDate: string | Date;
}

export const BottomTimer = ({ endDate }: BottomTimerProps) => {
  const eventEndDate = dayjs(endDate).endOf('day');

  const {
    leftDays,
    leftHours,
    leftMinutes,
    leftSeconds,
    leftMilliseconds,
    isExpired,
  } = useRemainingTime({ endDate: eventEndDate });

  if (isExpired) return null;

  return (
    <div className="sticky bottom-0 mt-auto gap-10 bg-Gray-black/60 p-12 flex-center">
      <span className="inline-flex min-h-30 items-center whitespace-nowrap rounded-r-pill bg-R-500 px-14 font-700 text-Gray-white typo-body4">
        마감까지
      </span>

      <p className={cn('font-500 text-Gray-white')}>
        <span style={{ fontFamily: FONT_FAMILY }}>{leftDays}</span>일{' '}
        <span style={{ fontFamily: FONT_FAMILY }}>{padNumber(leftHours)}</span>
        시간{' '}
        <span style={{ fontFamily: FONT_FAMILY }}>
          {padNumber(leftMinutes)}
        </span>
        분{' '}
        <span style={{ fontFamily: FONT_FAMILY }}>
          {padNumber(leftSeconds)}
        </span>
        초{' '}
        <span style={{ fontFamily: FONT_FAMILY }}>
          {padNumber(Math.floor(leftMilliseconds / 10))}
        </span>
      </p>
    </div>
  );
};
